function appendTooltipRow(tooltipEl, label, value) {
  const row = document.createElement('div');
  row.className = 'history-revenue-chart-tooltip__row';

  const labelEl = document.createElement('span');
  labelEl.textContent = label;

  const valueEl = document.createElement('span');
  valueEl.textContent = value;

  row.appendChild(labelEl);
  row.appendChild(valueEl);
  tooltipEl.appendChild(row);
}

function getOrCreateTooltip(chart) {
  const parent = chart.canvas.parentNode;
  if (!parent) {
    return null;
  }

  let tooltipEl = parent.querySelector('.history-revenue-chart-tooltip');
  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.className = 'history-revenue-chart-tooltip';
    tooltipEl.setAttribute('role', 'tooltip');
    parent.appendChild(tooltipEl);
  }

  return tooltipEl;
}

export function createRevenueChartExternalTooltip(visibleData, t) {
  return function externalTooltip(context) {
    const { chart, tooltip } = context;
    const tooltipEl = getOrCreateTooltip(chart);

    if (!tooltipEl) {
      return;
    }

    if (tooltip.opacity === 0) {
      tooltipEl.style.opacity = '0';
      return;
    }

    const dataIndex = tooltip.dataPoints?.[0]?.dataIndex;
    const item = typeof dataIndex === 'number' ? visibleData[dataIndex] : null;

    if (!item) {
      tooltipEl.style.opacity = '0';
      return;
    }

    const currency = t('currency').trim();
    const kwhValue = Number(item.kwh.toFixed(3)).toString();
    tooltipEl.replaceChildren();
    appendTooltipRow(tooltipEl, t('historyPage.revenueChartTooltipCharged'), `${kwhValue} ${t('wt')}`);
    appendTooltipRow(
      tooltipEl,
      t('historyPage.revenueChartTooltipSpent'),
      `${item.revenue.toFixed(2)}${currency ? ` ${currency}` : ''}`
    );
    appendTooltipRow(tooltipEl, t('historyPage.revenueChartTooltipAvgPower'), `${item.avgPower.toFixed(1)} ${t('kW')}`);

    const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;
    tooltipEl.style.opacity = '1';
    tooltipEl.style.left = `${positionX + tooltip.caretX}px`;
    tooltipEl.style.top = `${positionY + tooltip.caretY - 8}px`;
    tooltipEl.style.transform = 'translate(-50%, -100%)';
  };
}
